import { isRemote } from '../env';
import { LocalResultsRepository } from './localRepository';
import { RemoteResultsRepository } from './remoteRepository';
import { IResultsRepository } from './IResultsRepository';
import { getAuthToken } from '../../auth/tokenProvider';

let instance: IResultsRepository | null = null;

export function getResultsRepository(getToken?: () => Promise<string | null>): IResultsRepository {
  if (!instance) {
    instance = isRemote ? new RemoteResultsRepository(getToken ?? getAuthToken) : new LocalResultsRepository();
  }
  return instance;
}
